export const common = {
  nav: {
    home: 'Početna',
    technologies: 'Tehnologije',
    finishing: 'Dorade',
    portfolio: 'Portfolio',
    preparation: 'Priprema',
    faq: 'FAQ',
    contact: 'Kontakt',
  },

  hero: {
    badge: 'Samolepljive etikete',
    established: 'Od 1991. godine',
    title1: 'Promedia',
    title2: 'Print',
    description:
      'Štampa koja ideju pretvara u prepoznatljiv proizvod',
    primaryCta: 'Pogledajte tehnologije',
    secondaryCta: 'Priprema za štampu',
  },

  technologies: {
    title: 'Tehnologije',
    titleBold: 'štampe',
    intro:
      'U zavisnosti od tiraža, materijala i namene etikete, predlažemo digitalnu ili flekso štampu.',
    digital: {
      title: 'Digitalna štampa',
      description:
        'Pogodna je za manje i srednje tiraže, više verzija dizajna i projekte kod kojih je važna fleksibilnost.',
    },
    flexo: {
      title: 'Flekso štampa',
      description:
        'Dobro rešenje za veće tiraže i stabilnu proizvodnju etiketa na rolni.',
    },
    consulting: {
      title: 'Priprema i konsultacije',
      description:
        'Možemo pomoći oko izbora tehnologije, materijala i dorade u skladu sa namenom etikete.',
      extraDescription:
        'Na taj način se pre početka izrade lakše usklađuju izgled, funkcionalnost i tehnički zahtevi etikete.',
    },
  },

  finishing: {
    badge: 'Dorade',
    title: 'Detalji koji menjaju izgled etikete',
    description:
      'Dorade se biraju prema dizajnu, materijalu i efektu koji etiketa treba da postigne.',
    items: {
      foil: {
        title: 'Zlatotisak',
        description:
          'Folija se koristi za naglašavanje logotipa, naziva proizvoda ili dekorativnih detalja.',
      },
      raised: {
        title: 'Bubreći lak',
        description:
          'Reljefni lak ističe određene elemente i dodaje taktilni efekat etiketi.',
      },
      screen: {
        title: 'Sito',
        description:
          'Sito omogućava izraženije nanose boje i posebne vizuelne efekte.',
      },
      effects: {
        title: 'Kombinovane dorade',
        description:
          'Različite dorade se mogu kombinovati kada to materijal, dizajn i tehnologija dozvoljavaju.',
      },
    },
  },

  portfolio: {
    title: 'Portfolio',
    titleBold: '',

    items: {
      wine: 'Teksturirani materijali',
      foil: 'Folija',
      matte: 'Mat završetak',
      glossy: 'Sjajni završetak',
      shape: 'Specijalni oblici',
      emboss: 'Reljefni detalji',
    },

    details: {
      wine:
        'Materijali sa teksturom često se koriste za proizvode sa prirodnijim ili elegantnijim vizuelnim stilom.',
      foil:
        'Folija naglašava izabrane detalje i može doprineti upečatljivijem izgledu etikete.',
      matte:
        'Mat završna obrada daje mirniji izgled i smanjuje refleksiju.',
      glossy:
        'Sjajna obrada ističe boje i daje izraženiji vizuelni efekat.',
      shape:
        'Štancovanje omogućava izradu etiketa u različitim oblicima.',
      emboss:
        'Reljefni detalji se koriste za isticanje logotipa, simbola ili dekorativnih elemenata.',
    },
  },

  preparation: {
    badge: 'Priprema za štampu',
    title: 'Preuzmite smernice za pripremu fajlova',
    description:
      'U PDF dokumentu se nalaze osnovne smernice za pripremu fajlova za štampu samolepljivih etiketa.',
    points: {
      format: 'Preporučeni formati fajlova',
      colors: 'Podešavanje boja za štampu',
      bleed: 'Napust, rezna linija i sigurnosna zona',
      resolution: 'Rezolucija slika i osnovni tehnički zahtevi',
    },
    download: 'Preuzmite PDF',
    cardTitle: 'Vodič za pripremu',
    cardText:
      'Dokument služi kao pomoć pri slanju fajlova i može ubrzati proveru pripreme pre ulaska u štampu.',
  },

  faq: {
    title: 'Često postavljana pitanja',
    description:
      'Odgovori na pitanja koja se najčešće javljaju pre početka izrade etiketa.',
    items: {
      digitalFlexo: {
        question: 'Koja je razlika između digitalne i flekso štampe?',
        answer:
          'Digitalna štampa je pogodna za manje i srednje tiraže, česte izmene i više verzija dizajna. Flekso štampa se češće koristi za veće tiraže i stabilnu proizvodnju na rolni.',
      },
      smallRuns: {
        question: 'Da li radite manje tiraže?',
        answer:
          'Da, u zavisnosti od vrste etikete i zahteva, manje tiraže se najčešće rade u digitalnoj štampi.',
      },
      filePreparation: {
        question: 'Da li pomažete oko pripreme fajlova?',
        answer:
          'Možemo pregledati fajl i ukazati na osnovne tehničke stvari koje treba ispraviti pre štampe.',
      },
      finishing: {
        question: 'Koje dorade mogu da se kombinuju?',
        answer:
          'Moguće su različite kombinacije dorada, kao što su folija, lak i sito, ali zavise od materijala, dizajna i tehnologije izrade.',
      },
      price: {
        question: 'Kako se formira cena etiketa?',
        answer:
          'Cena zavisi od dimenzije, količine, materijala, tehnologije štampe, dorade i složenosti pripreme.',
      },
    },
  },

  contact: {
    title: 'Kontakt',
    titleBold: 'informacije',
    description:
      'Za upite u vezi sa izradom etiketa možete nas kontaktirati putem email-a ili telefona.',
    email: {
      title: 'Email',
      description: 'Pošaljite nam osnovne informacije o etiketi.',
      address: 'promedia@orion.rs',
    },
    location: {
      mapEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11322.584368680678!2d20.4922909!3d44.80840069999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a658bddcf2c37%3A0xbcbf4ba404fff117!2sPROMEDIA%20d.o.o.!5e0!3m2!1sen!2srs!4v1765663832235!5m2!1sen!2srs',
    },
    phone: {
      title: 'Telefon',
      description: 'Za dodatne informacije možete nas pozvati.',
      number: '+381 11 3321919',
    },
  },

  footer: {
    tagline: 'Samolepljive etikete u digitalnoj i flekso štampi.',
  },
};